import React, { useMemo } from 'react';
import { useData } from '@microsoft/teamsfx-react';
import { Spinner } from '@fluentui/react-components';
import { observer } from 'mobx-react-lite';

import { CHALLENGES_CONFIG, TOOL_IDS } from 'src/utils/constants';
import NoPrograms from 'src/components/atoms/no-programs/NoPrograms';
import ChallengeItem from 'src/components/molecules/challenge-item/ChallengeItem';
import { useStore } from 'src/hooks/useStore';
import { getToolName } from 'src/utils/utils';
import { Challenges } from 'src/models/Challenges';
import WidgetContainer from '../../molecules/widget-container/WidgetContainer';
import { useChallengeSectionStyles } from './ChallengesSection.styles';

const ChallengesSection: React.FC = () => {
  const { profileStore, activitiesStore } = useStore();
  const styles = useChallengeSectionStyles();

  const challengeToolName = getToolName(TOOL_IDS.CHALLENGE, profileStore.profile?.enabledTools);
  const { loading: isChallengesLoading, error: loadChallengesError } = useData(activitiesStore.loadActivities);

  if (loadChallengesError) {
    throw loadChallengesError;
  }

  const renderItems = useMemo(() => {
    const challenges = activitiesStore.activities || [];
    if (!challenges || challenges?.length === 0) return <NoPrograms />;

    return challenges.map((challenge: Challenges) => {
      const { icon: Icon, color } = CHALLENGES_CONFIG[challenge.type] || { icon: null, color: '' };
      return (
        <ChallengeItem
          actionText={challenge.actionText}
          actionUri={challenge.actionUri}
          name={challenge.name}
          description={challenge.description}
          key={challenge.externalId || challenge.battleId}
          icon={Icon
            ? <Icon color={color} />
            : null}
          accentColor={color}
        />
      );
    });
  }, [activitiesStore.activities]);

  if (isChallengesLoading) return <Spinner />;

  return (
    <WidgetContainer title={challengeToolName}>
      <div className={styles.cardsContainer}>{renderItems}</div>
    </WidgetContainer>
  );
};

export default observer(ChallengesSection);
